import { defineRule } from 'vee-validate'

const isValid = value =>
  new Promise(resolve => {
    const date = new Date(value).getTime()
    const now = new Date().getTime()
    const oneDay = 86400000 // ms
    return resolve(date < now - oneDay)
  })

defineRule('birthdate', value => {
  return isValid(value) || this.$t('form.invalid_birthdate')
})
